<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <router-link v-if="item.childrens.length === 0&&item.url!==undefined" :to="item.url === '/' ? '' : item.url" :key="item.title">
        <el-menu-item class='submenu-title-noDropdown' :index="item.id + item.level + item.url">
          <svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
          <span>{{item.title}}</span>
        </el-menu-item>
      </router-link>
      <el-submenu v-else :index="item.id + item.level + item.url" :key="item.id">
        <template slot="title">
          <svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
          <span>{{item.title}}</span>
        </template>
        <template v-for="child in item.childrens">
          <sidebar-item class="nest-menu" v-if="child.childrens && child.childrens.length > 0" :routes="[child]" :key="child.id"></sidebar-item>
          <a v-else @click.prevent="goMenu(child)">
            <el-menu-item :index="child.id + child.level + child.url">
              <svg-icon v-if="child.icon" :icon-class="child.icon"></svg-icon>
              <span>{{child.title}}</span>
            </el-menu-item>
          </a>
        </template>
      </el-submenu>
    </template>
  </div>
</template>
<script>
  import {setMenuId} from '@/utils/auth' // 设置menuid

  export default {
    name: 'sidebarItem',
    props: {
      routes: {
        type: Array
      }
    },
    methods: {
      goMenu(item) {
        let a= {"menuId":item.id}
        this.$fetchData(this.$api.fwActionLog.add,a,'post').then(res=>{

        })
        if (item.id) {
          setMenuId(item.id)
        }
        if (item.params) {
          this.$router.push({
            path: item.url,
            query: {
              params: item.params
            }
          })
        } else {
          this.$router.push({path: item.url})
        }
      }
    }
  }
</script>
